module.exports = __webpack_public_path__ + "static/media/mind.51b95deb.svg";